<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <h3>REPORTE SERNAPESCA</h3>
          </div>
          <div class="col-6 text-right">
            <button class="btn btn-primary btn-icon" @click="cargar_datos">
              <i class="fas fa-filter"></i> Filtrar
            </button>
            <button class="btn btn-success btn-icon" @click="exportar_excel">
              <i class="fas fa-file-excel"></i> Excel
            </button>
          </div>
        </div>

        <!-- nuevo diseño -->
        <div class="row mt-2">
          <div class="col">
            <table class="table table-bordered">
              <tr class="background-light">
                <th>RANGO DE FECHAS</th>
                <th>TICKET</th>
                <th>GUÍA</th>
                <th>PROVEEDOR</th>
                <th>MATERIA PRIMA</th>
                <th>ESPECIE</th>
                <!-- <th>PRODUCTO</th>
                                <th>DESTINO</th> -->
              </tr>
              <tr>
                <td>
                  <date-picker
                    v-model="fechas"
                    :range="true"
                    format="DD-MM-YYYY"
                    :editable="false"
                    :clearable="true"
                    value-type="YYYY-MM-DD"
                  ></date-picker>
                </td>
                <td>
                  <input type="number" name="" id="" v-model="codigo_ticket" />
                </td>
                <td>
                  <input type="number" name="" id="" v-model="numero_guia" />
                </td>
                <td>
                  <v-select
                    class=""
                    :reduce="(option) => option.id"
                    v-model="empresas_id"
                    :closeOnSelect="false"
                    :options="proveedores"
                    label="nombre"
                    multiple
                  >
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        No se Encontraron Resultados Para <em>{{ search }}</em
                        >.
                      </template>
                      <em style="opacity: 0.5" v-else
                        >Escriba para Filtrar...</em
                      >
                    </template>
                  </v-select>
                </td>
                <td>
                  <v-select
                    class=""
                    :reduce="(option) => option.id"
                    v-model="mps_id"
                    :options="materias_primas"
                    label="nombre"
                    multiple
                    @input="obtener_parametros_mp()"
                  >
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        No se Encontraron Resultados Para <em>{{ search }}</em
                        >.
                      </template>
                      <em style="opacity: 0.5" v-else
                        >Escriba para Filtrar...</em
                      >
                    </template>
                  </v-select>
                  <!-- <select name="" id="" v-model="mps_id" @change="obtener_parametros_mp()">
                                        <option :value="mp.id" v-for="mp in materias_primas" :key="mp.id">{{mp.nombre}}</option>
                                    </select> -->
                </td>
                <td>
                  <v-select
                    class=""
                    :reduce="(option) => option.id"
                    v-model="especies_id"
                    :options="especies"
                    label="nombre"
                    multiple
                  >
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        No se Encontraron Resultados Para <em>{{ search }}</em
                        >.
                      </template>
                      <em style="opacity: 0.5" v-else
                        >Escriba para Filtrar...</em
                      >
                    </template>
                  </v-select>
                </td>
                <!-- <td>
                                    <v-select class="" :reduce="option => option.id" v-model="productos_ids" :options="productos" label="nombre" multiple>
                                        <template v-slot:no-options="{ search, searching }">
                                        <template v-if="searching">
                                            No se Encontraron Resultados Para <em>{{ search }}</em>.
                                        </template>
                                        <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                        </template>
                                    </v-select>
                                </td>
                                <td>
                                    <v-select class="" :reduce="option => option.id" v-model="destinos_id" :options="destinos" label="nombre" multiple>
                                        <template v-slot:no-options="{ search, searching }">
                                        <template v-if="searching">
                                            No se Encontraron Resultados Para <em>{{ search }}</em>.
                                        </template>
                                        <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                        </template>
                                    </v-select>
                                </td> -->
              </tr>
            </table>
          </div>
        </div>

        <!-- nuevo diseño -->

        <div class="row">
          <div class="col">
            <div class="accordion" id="accordionExample">
              <div class="card">
                <div
                  class="card-header background-blue-2"
                  id="headingOne"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  <h5 class="mb-0">Configuracion Columnas a Mostrar</h5>
                </div>
                <div
                  id="collapseOne"
                  class="collapse show"
                  aria-labelledby="headingOne"
                  data-parent="#accordionExample"
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col">
                        <div class="table-responsive">
                          <table class="table">
                            <tr class="thead-skyblue2">
                              <th :colspan="columnas.length">
                                <label class="margen-1" for=""
                                  ><input
                                    type="checkbox"
                                    id=""
                                    value=""
                                    v-model="todos"
                                    @change="setearTodos"
                                  />
                                  Todos</label
                                >
                              </th>
                            </tr>

                            <tr>
                              <td v-for="col in columnas" :key="col.label">
                                <label class="margen-1" for=""
                                  ><input
                                    type="checkbox"
                                    id=""
                                    value=""
                                    v-model="col.show"
                                  />
                                  {{ col.label }}</label
                                >
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col">
                        <label class="margen-1" for=""
                          ><input
                            type="checkbox"
                            id=""
                            value=""
                            v-model="agrupar_empresa"
                          />
                          Empresa Principal</label
                        >
                        <label class="margen-1" for=""
                          ><input
                            type="checkbox"
                            id=""
                            value=""
                            v-model="agrupar_sucursal"
                          />
                          Sucursal Principal</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row">
                    <div class="col">
                        <label class="" for="" ><input type="checkbox" id="" value="" v-model="todos" @change="setearTodos"> Todos</label>

                        <label class="" for="" v-for="col in columnas" :key="col.label"><input type="checkbox" id="" value="" v-model="col.show"> {{col.label}}</label>

                        
                    </div>
                </div> -->

        <div class="row mt-1">
          <div class="col">
            <div class="tableFixHead" style="width: 100%">
              <table class="table table-bordered">
                <thead class="">
                  <tr>
                    <th
                      class="fixed thead-skyblue2 text-center"
                      v-for="c in columnas"
                      :key="c.label"
                      v-show="c.show"
                    >
                      {{ c.label }}
                    </th>
                  </tr>
                  <!-- <tr>
                                            <th class="fixed-2"></th>
                                            <th class="fixed-2 text-center" v-for="m in mps_seleccionadas" :key="m.id">
                                                <table>
                                                    <tr>
                                                        <td style="width:100%">C/R</td>
                                                        <td style="width:100%">S/R</td>
                                                    </tr>
                                                </table>
                                            </th>
                                        </tr> -->
                </thead>
                <tbody>
                  <tr
                    v-for="d in datos"
                    :key="d.id"
                    v-bind:class="{
                      'background-red-2': d.marcar_rojo == 1,
                      'background-light': d.seleccionado == 1,
                    }"
                  >
                    <td
                      class="text-center"
                      v-for="c in columnas"
                      :key="c.label"
                      v-show="c.show"
                      @click="
                        d.seleccionado == 1
                          ? (d.seleccionado = 0)
                          : (d.seleccionado = 1)
                      "
                    >
                      <!-- <span v-if="c.path == 'declaracion_jurada'">
                                                    <button v-show="c.path == 'declaracion_jurada' && d.declaracion_jurada != null" class="btn btn-primary btn-sm" type="button" @click="abrirDeclaracion(d)">
                                                        <span class="btn-inner--icon"><i class="fas fa-file-pdf"></i></span>
                                                    </button>
                                                </span>

                                                <span v-if="c.path == 'cam'">
                                                    <button v-show="c.path == 'cam' && d.cam != null" class="btn btn-warning btn-sm" type="button" @click="abrirCam(d)">
                                                        <span class="btn-inner--icon"><i class="fas fa-file-pdf"></i></span>
                                                    </button>
                                                </span> -->

                      <span
                        v-if="c.path != 'declaracion_jurada' && c.path != 'cam'"
                        >{{ devuelve_valor(d, c.path, c.tipo) }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <table class="table table-bordered">
              <thead class="thead-blue">
                <tr>
                  <th class="text-center">TOTAL PESO INFORMADO (TON)</th>
                  <th class="text-center">TOTAL PESO RECIBIDO (TON)</th>
                  <th class="text-center">TOTAL PESO DISTRIBUCIÓN (KG)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="total_resultado">
                  <td class="text-center">
                    {{
                      total_resultado.total_peso_informado_toneladas
                        | formatear_miles
                    }}
                  </td>
                  <td class="text-center">
                    {{
                      total_resultado.total_peso_recibido_toneladas
                        | formatear_miles
                    }}
                  </td>
                  <td class="text-center">
                    {{ total_resultado.total_distribucion | formatear_miles }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- <pre>{{mes}}</pre>
                <pre>{{anio}}</pre>
                <pre>{{inicio}}</pre>
                <pre>{{fin}}</pre>
                <pre>{{getDates}}</pre> -->
        <!-- <pre>{{fechas}}</pre> -->
        <!-- <pre>{{total_resultado}}</pre> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    fechas: [],
    todos: true,
    columnas: [
      {
        show: true,
        label: "FECHA|HORA INGRESO",
        tipo: "string",
        path: "fecha_hora_ingreso",
        ancho_excel: 22,
      },
      {
        show: true,
        label: "FECHA RECEPCIÓN",
        tipo: "fecha",
        path: "fecha_recepcion",
        ancho_excel: 20,
      },
      {
        show: true,
        label: "HORA RECEPCIÓN",
        tipo: "hora",
        path: "hora_recepcion",
        ancho_excel: 20,
      },
      {
        show: true,
        label: "FECHA|HORA ORIGEN",
        tipo: "string",
        path: "fecha_hora_origen",
        ancho_excel: 20,
      },
      {
        show: true,
        label: "N° TICKET",
        tipo: "string",
        path: "codigo_ticket",
        ancho_excel: 20,
      },
      {
        show: true,
        label: "PATENTE",
        tipo: "string",
        path: "patente",
        ancho_excel: 20,
      },
      {
        show: true,
        label: "FECHA GD",
        tipo: "string",
        path: "fecha_guia",
        ancho_excel: 20,
      },
      {
        show: true,
        label: "N° D.TRIBUTARIO",
        tipo: "string",
        path: "numero_guia",
        ancho_excel: 20,
      },
      {
        show: true,
        label: "FOLIO PCC",
        tipo: "string",
        path: "folio_guia",
        ancho_excel: 20,
      },
      {
        show: true,
        label: "CODIGO PROVEEDOR",
        tipo: "string",
        path: "siep_empresa",
        ancho_excel: 20,
      },
      {
        show: true,
        label: "NOMBRE PROVEEDOR",
        tipo: "string",
        path: "empresa",
        ancho_excel: 40,
      },
      {
        show: true,
        label: "CODIGO AGENTE ORIGEN",
        tipo: "string",
        path: "siep_sucursal",
        ancho_excel: 20,
      },
      {
        show: true,
        label: "NOMBRE AGENTE ORIGEN",
        tipo: "string",
        path: "sucursal",
        ancho_excel: 40,
      },
      {
        show: true,
        label: "CR/SR",
        tipo: "string",
        path: "tiene_restriccion",
        ancho_excel: 20,
      },
      {
        show: true,
        label: "RESTRICCIÓN",
        tipo: "string",
        path: "restricciones",
        ancho_excel: 20,
      },
      {
        show: true,
        label: "TIPO MMPP",
        tipo: "string",
        path: "materia_prima",
        ancho_excel: 20,
      },
      {
        show: true,
        label: "ESPECIE",
        tipo: "string",
        path: "especie",
        ancho_excel: 20,
      },
      {
        show: true,
        label: "PRODUCTO",
        tipo: "string",
        path: "productos_recibidos",
        ancho_excel: 20,
      },
      {
        show: true,
        label: "DESTINO",
        tipo: "string",
        path: "destino_distribucion",
        ancho_excel: 25,
      },

      {
        show: true,
        label: "BINS",
        tipo: "string",
        path: "cantidad_bins",
        ancho_excel: 20,
      },
      //{show:true,label:'Neto Informado (Ton)',tipo:'string',path:'peso_informado_guia_ton'},
      {
        show: true,
        label: "NETO INFORMADO GUÍA (KG)",
        tipo: "numero",
        path: "peso_informado_guia_kg",
        ancho_excel: 25,
      },
      {
        show: true,
        label: "NETO CORREGIDO GUÍA (KG)",
        tipo: "numero",
        path: "peso_real_guia_kg",
        ancho_excel: 25,
      },
      {
        show: true,
        label: "NETO DISTRIBUCIÓN (KG)",
        tipo: "numero",
        path: "peso_real_distribucion_kg",
        ancho_excel: 25,
      },
      {
        show: true,
        label: "NETO INFORMADO GUÍA (Ton)",
        tipo: "decimal",
        path: "peso_informado_guia_ton",
        ancho_excel: 25,
      },
      {
        show: true,
        label: "NETO CORREGIDO GUÍA (Ton)",
        tipo: "decimal",
        path: "peso_real_guia_ton",
        ancho_excel: 25,
      },
      {
        show: true,
        label: "NETO DISTRIBUCIÓN (Ton)",
        tipo: "decimal",
        path: "peso_real_distribucion_ton",
        ancho_excel: 25,
      },

      //{show:true,label:'Neto Corregido Guía (Ton)',tipo:'string',path:'peso_real_guia_ton'},
      //{show:true,label:'Neto Distribucion (Ton)',tipo:'string',path:'peso_real_distribucion_ton'},

      {
        show: true,
        label: "% GUÍA",
        tipo: "string",
        path: "porcentaje_guia",
        ancho_excel: 20,
      },
      {
        show: true,
        label: "PESO POR GUÍA (Ton)",
        tipo: "string",
        path: "peso_real_guia_ton",
        ancho_excel: 20,
      },

      {
        show: true,
        label: "TIEMPO TRASLADO (HRS)",
        tipo: "string",
        path: "horas_traslado",
        ancho_excel: 30,
      },
      {
        show: true,
        label: "MENOS DE 24 HORAS DE TRASLADO O REFRIGERADO",
        tipo: "string",
        path: "cumple_24_hrs",
        ancho_excel: 30,
      },

      {
        show: true,
        label: "CODIGO CENTRO ORIGEN",
        tipo: "string",
        path: "codigos_centros",
        ancho_excel: 25,
      },
      {
        show: true,
        label: "NOMBRE CENTRO ORIGEN",
        tipo: "string",
        path: "nombre_centros",
        ancho_excel: 25,
      },

      {
        show: true,
        label: "JAULA ORIGEN",
        tipo: "string",
        path: "jaulas_centros",
        ancho_excel: 25,
      },
    ],

    proveedores: [],
    datos: [],
    mps_id: [],
    destinos_id: [],
    empresas_id: [],
    especies_id: [],
    materias_primas: [],
    especies: [],
    mps_seleccionadas: [],
    destinos: [],
    total_resultado: null,
    url_excel: null,
    agrupar_empresa: true,
    agrupar_sucursal: true,
    codigo_ticket: "",
    numero_guia: "",
  }),
  mounted() {
    this.cargar_materias_primas();
  },
  methods: {
    async cargar_materias_primas() {
      await this.axios
        .get(`${this.api}/mps_tipo?limit=999999999`, this.cabeceras_json)
        .then((res) => {
          this.materias_primas = res.data.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_destinos();
    },

    async cargar_destinos() {
      await this.axios
        .get(`${this.api}/destinos`, this.cabeceras_json)
        .then((res) => {
          this.destinos = res.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_proveedores();
    },

    async cargar_proveedores() {
      /* await this.axios.get(`${this.api}/empresas?tipo_empresa_ids=4&agrupada_en_null=not_null&limit=9999999999`,this.cabeceras_json).then((res)=>{
            this.proveedores = res.data.data.data
            ////console.log('res',res.data.data.data);
          }).catch((e)=>{
            //console.log(e);
          }); */
      await this.axios
        .get(`${this.api}/proveedores`, this.cabeceras_json)
        .then((res) => {
          this.proveedores = res.data.data;
          console.log("res", res.data.data);
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_especies();
    },

    async cargar_especies() {
      await this.axios
        .get(`${this.api}/especies?limit=9999999999`, this.cabeceras_json)
        .then((res) => {
          this.especies = res.data.data.data;
        })
        .catch((e) => {
          //console.log(e);
        });
    },

    async filtrarProveedores(search) {
      await this.axios
        .get(
          `${this.api}/empresas?nombre=${search}&tipo_empresa_ids=4&agrupada_en_null=not_null&limit=9999999999`,
          this.cabeceras_json
        )
        .then((res) => {
          this.proveedores = res.data.data.data;
          ////console.log('res',res.data.data.data);
        })
        .catch((e) => {
          //console.log(e);
        });
      ////console.log('search',search)
      ////console.log('col',col)
    },

    async cargar_datos() {
      let loader = this.$loading.show({
        // Optional parameters
        //container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        color: "#262b63",
        backgroundColor: "#ededed",
        //onCancel: this.onCancel,
        loader: "spinner",
      });
      //if(this.fechas[0] != null && this.fechas[0] != undefined){
      let body = {
        mps_id: this.mps_id,
        //empresas_id:this.empresas_id,
        destinos_id: this.destinos_id,
        especies_id: this.especies_id,
        agrupar_empresa: this.agrupar_empresa,
        agrupar_sucursal: this.agrupar_sucursal,
        columnas: this.columnas
          .filter((c) => c.show == true)
          .map((c) => {
            return {
              cabecera: c.label,
              path: c.path,
              tipo: c.tipo,
              ancho_excel: c.ancho_excel,
            };
          }),
      };

      if (this.empresas_id.length > 0) {
        body.empresas_id = this.empresas_id;
      }

      if (this.fechas[0] != null && this.fechas[0] != undefined) {
        body.desde = this.fechas[0];
        body.hasta = this.fechas[1];
      }

      if (this.codigo_ticket) {
        body.codigo_ticket = this.codigo_ticket;
      }
      if (this.numero_guia) {
        body.numero_guia = this.numero_guia;
      }

      await this.axios
        .post(`${this.api}/reportes/sernapesca`, body, this.cabeceras_json)
        .then((res) => {
          //console.log(res.data.data);
          this.datos = res.data.data.data;
          this.total_resultado = res.data.data.total;
          this.url_excel = res.data.data.url_excel;
          loader.hide();
        })
        .catch((e) => {
          //console.log(e);
          loader.hide();
        });
      //}
    },

    async exportar_excel() {
      window.open(this.url_excel, "_blank");
      /* let body = {
                desde:this.fechas[0],
                hasta:this.fechas[1],
                mps_id:this.mps_id,
                empresas_id:this.empresas_id,
                destinos_id:this.destinos_id,
                especies_id:this.especies_id,
                agrupar_empresa:this.agrupar_empresa,
                agrupar_sucursal:this.agrupar_sucursal,
                columnas:this.columnas.filter(c => c.show == true && c.path != 'declaracion_jurada' && c.path != 'cam').map((c)=>{
                    return {cabecera:c.label,path:c.path}
                })
            };
            await this.axios.post(`${this.api}/reportes/personalizado_excel`,body,this.cabeceras_json).then((res)=>{
                this.url_excel = res.data.data.url;
                window.open(this.url_excel, '_blank');
                //console.log(this.url_excel,res.data);
            }).catch((e)=>{
                //console.log(e);
            }); */
    },

    devuelve_valor(item, path, tipo_dato) {
      let keys = path.split(".");
      let valor = item;
      keys.forEach((k) => {
        for (var key in valor) {
          if (key == k) {
            valor = valor[key];
          }
        }
      });
      if (tipo_dato == "datetime") {
        valor = this.$options.filters.fecha_hora(valor);
      }
      if (tipo_dato == "date") {
        valor = this.$options.filters.fecha(valor);
      }
      if (tipo_dato == "time") {
        valor = this.$options.filters.hora(valor);
      }
      return valor;
    },

    setearTodos() {
      this.columnas.forEach((c) => {
        c.show = this.todos;
      });
    },

    abrirPdf(d) {
      window.open(`${this.api_public}/guias/${d.url_guia}`, "_blank");
    },

    abrirDeclaracion(d) {
      window.open(
        `${this.api_public}/guias/archivos_adicionales/${d.declaracion_jurada}`,
        "_blank"
      );
    },

    abrirCam(d) {
      window.open(
        `${this.api_public}/guias/archivos_adicionales/${d.cam}`,
        "_blank"
      );
    },
  },
  computed: {
    ...mapState(["api", "api_public", "cabeceras_json", "token"]),
  },
};
</script>
<style>
.tableFixHead {
  overflow: auto;
  height: 600px;
  border: 1px solid rgb(212, 212, 212);
}
/*.tableFixHead thead th { position: sticky; top: 0; z-index: 100; }*/

.fixed {
  position: sticky;
  top: 0;
  z-index: 100;
}

/* Just common table stuff. Really. */
table {
  border-collapse: collapse;
  width: 100%;
}
th,
td {
  padding: 8px 16px;
}
/*th     { background:#427391; color:#fff }*/
.margen-1 {
  margin: 0em 0.5em;
}
</style>